import Reveal from "@/components/base/Reveal";
import { latestUpdates } from "@/mocks/drama";

export default function LatestUpdates() {
  return (
    <section id="latest" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <p className="flex items-center gap-2 font-label text-sm tracking-[0.3em] text-accent-400">
                <i className="ri-time-line" />
                最 新 剧 情
              </p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                近期补充的解析与线索
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-300">
              已经看过剧集的话，可以直接从这里进入最近的解析方向，省去逐段查找的时间。
            </p>
          </div>
        </Reveal>

        <ol className="mt-12 space-y-4">
          {latestUpdates.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 60}>
              <li className="group flex flex-col gap-4 rounded-lg border border-foreground-800 bg-foreground-900 p-5 transition hover:border-accent-600 md:flex-row md:items-center md:gap-6 md:p-6">
                <div className="flex items-center gap-4 md:w-40 md:shrink-0 md:flex-col md:items-start md:gap-2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="rounded-full bg-foreground-800 px-3 py-1 text-xs text-accent-400">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-300">{item.desc}</p>
                </div>
                <a
                  href={item.link}
                  className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-foreground-700 px-4 py-2 text-sm text-background-100 transition group-hover:border-accent-500 group-hover:text-accent-400"
                >
                  {item.linkText}
                  <i className="ri-arrow-right-line" />
                </a>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}